<template>
  <div>
    <form class="form-horizontal">
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.cardNumber') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.invoice.student.card_number"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.student') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.invoice.student.full_name_en"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.sex') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.invoice.student.gender"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.invoiceNumber') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.invoice.inv_number"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.paymentDate') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.payment_date"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.amount') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.inv_amount"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.paidAmountUsd') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.amount_paid"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.paidAmountKhr') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.amount_paid_khr"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.amountDue') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.amount_due"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.exchangeRate') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.exchange_rate"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.nextPaymentDate') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.next_payment_date"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
      <div class="row">
        <label class="col-md-5 col-form-label"
          >{{ $t('receipt.comment') }} :
        </label>
        <div class="col-md-7">
          <input
            type="text"
            readonly
            v-model="resource.comment"
            class="form-control-plaintext mb-2"
          />
        </div>
      </div>
    </form>
  </div>
</template>
<script>
export default {
  name: 'receiptView',
  props: ['resource'],
  data() {
    return {}
  }
}
</script>

<style lang="css" scoped>
label {
  font-size: 12px !important;
}
</style>
